import { InputBase } from '@mui/material';
import Fuse from 'fuse.js';
import { useState, useMemo, useEffect } from 'react';
import { useStockItemsQuery } from '@features/stock/queries';
import { mapStocksStockItemsToFlatStockItems } from '@features/stock/entity';
import { setGoodsSearchResults } from '@libs/redux/materialSearchResultsReducer';
import { useAppDispatch } from '@libs/redux/store';
import { useDebounce } from '@shared/store';
import { useIntl } from 'react-intl';

const GoodsSearch = () => {
  const intl = useIntl();
  const { data: stocksWithItems } = useStockItemsQuery(undefined);
  const allItems = mapStocksStockItemsToFlatStockItems(stocksWithItems) ?? [];
  const goodsItems = useMemo(() => allItems.filter(i => i.itemType === 'GOODS'), [allItems]);

  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 200);
  const dispatch = useAppDispatch();

  const fuse = useMemo(
    () =>
      new Fuse(goodsItems, {
        keys: ['itemName', 'brand'],
        threshold: 0.4,
      }),
    [goodsItems],
  );

  const results = useMemo(
    () =>
      debouncedQuery.trim()
        ? fuse.search(debouncedQuery).map(r => r.item)
        : goodsItems.slice(0, 10),
    [debouncedQuery, fuse, goodsItems],
  );

  useEffect(() => {
    dispatch(setGoodsSearchResults(results));
  }, [results, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setGoodsSearchResults([]));
    };
  }, [dispatch]);

  return (
    <InputBase
      placeholder={intl.formatMessage({ id: 'search.goods' })}
      value={query}
      onChange={e => setQuery(e.target.value)}
      sx={{ color: '#ffffff' }}
    />
  );
};

export default GoodsSearch;
